import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import OffersPage from '../pages/OffersPage'
import MyJobsPage from '../pages/MyJobsPage'
import Toolbar from '@material-ui/core/Toolbar';


function NavBar(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

NavBar.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
            <Typography variant="h6" className={classes.title}>
                CONVOY
            </Typography>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Offers" {...a11yProps(0)} />
            <Tab label="My Jobs" {...a11yProps(1)} />
            </Tabs>
        </Toolbar>

      </AppBar>
      <NavBar value={value} index={0}>
        <OffersPage />
      </NavBar>
      <NavBar value={value} index={1}>
        <MyJobsPage />
      </NavBar>
    </div>
  );
}
